import { render, staticRenderFns } from "./ZendeskArticle.vue?vue&type=template&id=de9016e8&scoped=true"
import script from "./ZendeskArticle.vue?vue&type=script&lang=js"
export * from "./ZendeskArticle.vue?vue&type=script&lang=js"
import style0 from "./ZendeskArticle.vue?vue&type=style&index=0&id=de9016e8&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "de9016e8",
  null
  
)

export default component.exports